// query
export const ON_QUERY_INPUT_CHANGE = 'ON_QUERY_INPUT_CHANGE';
export const START_LOAD_RATING_MANAGEMENT_INFO = 'START_LOAD_RATING_MANAGEMENT_INFO';
export const LOAD_RATING_MANAGEMENT_INFO_SUCCESS = 'LOAD_RATING_MANAGEMENT_INFO_SUCCESS';
export const LOAD_RATING_MANAGEMENT_INFO_FAILURE = 'LOAD_RATING_MANAGEMENT_INFO_FAILURE';
export const INIT_LOAD_RATING_MANAGEMENT_INFO_ACTION_STATUS = 'INIT_LOAD_RATING_MANAGEMENT_INFO_ACTION_STATUS';
// select
export const SELECT_RATING_MANAGEMENT_INFO = 'SELECT_RATING_MANAGEMENT_INFO';
// add or edit
export const OPEN_ADD_OR_EDIT_RATING_MANAGEMENT_MODAL = 'OPEN_ADD_OR_EDIT_RATING_MANAGEMENT_MODAL';
export const ADD_OR_EDIT_RATING_MANAGEMENT_CHANGE_INPUT = 'ADD_OR_EDIT_RATING_MANAGEMENT_CHANGE_INPUT';
export const START_ADD_OR_EDIT_RATING_MANAGEMENT = 'START_ADD_OR_EDIT_RATING_MANAGEMENT';
export const ADD_OR_EDIT_RATING_MANAGEMENT_SUCCESS = 'ADD_OR_EDIT_RATING_MANAGEMENT_SUCCESS';
export const ADD_OR_EDIT_RATING_MANAGEMENT_FAILURE = 'ADD_OR_EDIT_RATING_MANAGEMENT_FAILURE';
export const INIT_ADD_OR_EDIT_RATING_MANAGEMENT_ACTION_STATUS = 'INIT_ADD_OR_EDIT_RATING_MANAGEMENT_ACTION_STATUS';
export const RESET_ADD_OR_EDIT_RATING_MANAGEMENT_MODAL = 'RESET_ADD_OR_EDIT_RATING_MANAGEMENT_MODAL';
// refresh fx and amtUSD
export const START_REFRESH_FX = 'START_REFRESH_FX';
export const REFRESH_FX_SUCCESS = 'REFRESH_FX_SUCCESS';
export const REFRESH_FX_FAILURE = 'REFRESH_FX_FAILURE';
export const INIT_REFRESH_FX_ACTION_STATUS = 'INIT_REFRESH_FX_ACTION_STATUS';
export const REFRESH_AMT_USD = 'REFRESH_AMT_USD';
// del
export const OPEN_DEL_RATING_MANAGEMENT_MODAL = 'OPEN_DEL_RATING_MANAGEMENT_MODAL';
export const DEL_RATING_MANAGEMENT_CHANGE_INPUT = 'DEL_RATING_MANAGEMENT_CHANGE_INPUT';
export const START_DEL_RATING_MANAGEMENT = 'START_DEL_RATING_MANAGEMENT';
export const DEL_RATING_MANAGEMENT_SUCCESS = 'DEL_RATING_MANAGEMENT_SUCCESS';
export const DEL_RATING_MANAGEMENT_FAILURE = 'DEL_RATING_MANAGEMENT_FAILURE';
export const INIT_DEL_RATING_MANAGEMENT_ACTION_STATUS = 'INIT_DEL_RATING_MANAGEMENT_ACTION_STATUS';
export const RESET_DEL_RATING_MANAGEMENT_MODAL = 'RESET_DEL_RATING_MANAGEMENT_MODAL';

// cop
export const OPEN_COP_RATING_MANAGEMENT_MODAL = 'OPEN_COP_RATING_MANAGEMENT_MODAL';
export const COP_RATING_MANAGEMENT_CHANGE_INPUT = 'COP_RATING_MANAGEMENT_CHANGE_INPUT';
export const START_COP_RATING_MANAGEMENT = 'START_COP_RATING_MANAGEMENT';
export const COP_RATING_MANAGEMENT_SUCCESS = 'COP_RATING_MANAGEMENT_SUCCESS';
export const COP_RATING_MANAGEMENT_FAILURE = 'COP_RATING_MANAGEMENT_FAILURE';
export const INIT_COP_RATING_MANAGEMENT_ACTION_STATUS = 'INIT_COP_RATING_MANAGEMENT_ACTION_STATUS';
export const RESET_COP_RATING_MANAGEMENT_MODAL = 'RESET_COP_RATING_MANAGEMENT_MODAL';

export const OPEN_RESTRICTED_RULE_FUND_BOOK_DIALOG = 'OPEN_RESTRICTED_RULE_FUND_BOOK_DIALOG';
export const CLOSE_RESTRICTED_RULE_FUND_BOOK_DIALOG = 'CLOSE_RESTRICTED_RULE_FUND_BOOK_DIALOG';
export const RESTRICTED_RULE_INPUT_CHANGE = 'RESTRICTED_RULE_INPUT_CHANGE';

export const LOAD_INSTITUTE_USER_ACCOUNT_SUCCESS = 'LOAD_INSTITUTE_USER_ACCOUNT_SUCCESS';
export const LOAD_INSTITUTE_USER_ACCOUNT_FAILURE = 'LOAD_INSTITUTE_USER_ACCOUNT_FAILURE';